import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  members: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  orderDetail: { data: null, loading: false },
  confirm: { name: '', title: '', content: '', visible: false, loading: false, active: null },
  searchParams: null,
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
